export default "/images/vendor/flag-icon-css/flags/4x3/mc.svg?a2634c60fa92f9ff20f08026a6a4b56e";